import { type UseQueryResult } from '@tanstack/react-query';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { queryKeys } from '../../../lib/api/query-keys.js';
import { roleEndpoints } from './endpoints.js';
import { roleDetail, type RoleDetail } from './schemas.js';

/**
 * Reads for the Roles module.
 */

export function useRoleDetail(roleId: string): UseQueryResult<RoleDetail> {
  return useApiQuery({
    queryKey: queryKeys.roles.detail(roleId),
    path: roleEndpoints.detail(roleId),
    schema: roleDetail,
    enabled: roleId !== '',
  });
}
